import { useState } from "react";
import { Box, Button, Stack, TextField, Typography, Alert } from "@mui/material";
import { useMutation } from "@apollo/client";
import { CREATE_CONTACT_MESSAGE } from "@dashboard/graphql/mutations/createContactMessage";
import { triggerNotification } from "@store/slices/notification";
import { useDispatch } from "react-redux";

const ContactPage = () => {
    const dispatch = useDispatch();

    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [createContactMessage, { loading }] = useMutation(CREATE_CONTACT_MESSAGE, {
        onCompleted: () => {
            setSubmitted(true);
            dispatch(
                triggerNotification({
                    type: "success",
                    title: "Nachricht gesendet",
                    content: "Danke für deine Nachricht! Wir melden uns schnellstmöglich.",
                    autoHideDuration: 4000,
                }),
            );
        },
        onError: (err) => {
            console.error(err);
            setError("Beim Versenden ist ein Fehler aufgetreten.");
        },
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        createContactMessage({ variables: { subject, message } });
    };

    return (
        <Box maxWidth={600} mx="auto" mt={4}>
            <Typography variant="h4" gutterBottom>
                Kontakt
            </Typography>
            <Typography variant="body1" paragraph>
                Hast du Fragen oder benötigst Unterstützung? Sende uns einfach eine Nachricht.
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Stack spacing={2}>
                    <TextField
                        label="Betreff"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Nachricht"
                        multiline
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        fullWidth
                        required
                    />
                    {error && <Alert severity="error">{error}</Alert>}
                    <Button variant="contained" type="submit" disabled={submitted || loading || !subject || !message}>
                        {submitted ? "Gesendet" : loading ? "Senden..." : "Absenden"}
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
};

export default ContactPage; 